import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  alpha,
  useTheme,
} from '@mui/material';
import { useQuery } from 'react-query';
import { getHolidayBalance } from '../../api/services/Candidate/holiday';
import HolidaySummary from '../Candidate/holiday/HolidaySummary';
import HolidayRequest from '../Candidate/holiday/HolidayRequest';
import HolidayHistory from '../Candidate/holiday/HolidayHistory';
import { QK } from '../../base/qk';
import { EventNote, BeachAccess, History, RequestPage } from '@mui/icons-material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`holiday-tabpanel-${index}`}
      aria-labelledby={`holiday-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
    </div>
  );
}

export default function Holiday({ candidateId }) {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState(0);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());

  const { data: balanceData } = useQuery(
    [QK.holidayBalance, candidateId, selectedYear],
    () => getHolidayBalance(candidateId, selectedYear),
    {
      enabled: !!candidateId && !!selectedYear,
      staleTime: 2 * 60 * 1000,
    }
  );

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const tabs = [
    { label: 'Summary', icon: <BeachAccess sx={{ fontSize: 18 }} />, value: 0 },
    { label: 'Request', icon: <RequestPage sx={{ fontSize: 18 }} />, value: 1 },
    { label: 'History', icon: <History sx={{ fontSize: 18 }} />, value: 2 },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '10px',
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <EventNote sx={{ color: theme.palette.primary.main, fontSize: 22 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} color="#1A1A2E">
            Holiday Management
          </Typography>
          <Typography variant="caption" color="#6B7280">
            Manage employee holidays and leave requests
          </Typography>
        </Box>
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: '1px solid #E2E8F0',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            bgcolor: '#F8FAFC',
            borderBottom: '1px solid #E2E8F0',
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              minHeight: 48,
              px: 2,
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.85rem',
                py: 1,
                minHeight: 48,
                color: '#64748B',
                '&.Mui-selected': {
                  color: '#2469F0',
                },
              },
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: '3px 3px 0 0',
                bgcolor: '#2469F0',
              },
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ p: 2.5 }}>
          <TabPanel value={tabValue} index={0}>
            <HolidaySummary
              candidateId={candidateId}
              selectedYear={selectedYear}
              onYearChange={handleYearChange}
            />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <HolidayRequest
              candidateId={candidateId}
              selectedYear={selectedYear}
              balanceData={balanceData}
              onSuccess={() => {}}
            />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <HolidayHistory
              candidateId={candidateId}
              selectedYear={selectedYear}
            />
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  );
}